export const DECISION_DIFFICULTY_FRAMEWORK_NAME = "decision_difficulty";
export const CONSEQUENTIAL_THINKING_FRAMEWORK_NAME = "consequential_thinking";

export interface DecisionMakingFramework {
  name: string;
  description: string;
  help_url: string;
  icon: string;
}

export const DECISION_MAKING_FRAMEWORKS: Record<string, DecisionMakingFramework> = {
  [DECISION_DIFFICULTY_FRAMEWORK_NAME]: {
    name: "Decision Difficulty",
    description:
      "Classify decisions by impact (high/low) and option comparability (easy/hard) to determine the right approach: quick choice or careful analysis.",
    help_url: "/decision-making-frameworks/decision-difficulty-framework/",
    icon: "",
  },
  [CONSEQUENTIAL_THINKING_FRAMEWORK_NAME]: {
    name: "Consequential Thinking",
    description:
      "Evaluate beyond immediate outcomes. Consider the second and third-order effects of your decisions to avoid short-term wins that become long-term losses.",
    help_url: "/decision-making-frameworks/consequential-thinking-framework/",
    icon: "",
  },
};
